
import { defineComponent, reactive } from "vue";
import Header from "@/components/Forms/Header.vue";
import ContactUsForm from "@/components/Forms/ContactUsForm.vue";
import { SendStoreLocatorForm, StoreLocatorTypeForm } from "@/interfaces";
import FormService from "@/services/FormService";

export default defineComponent({
  name: "ContactUs",
  components: {
    Header,
    ContactUsForm,
  },
  setup() {
    const form = reactive<SendStoreLocatorForm>({
      name: "",
      lastname: "",
      email: "",
      telephone: "",
      province: "",
      city: "",
      organizationName: "",
      type: "",
      dealerType: StoreLocatorTypeForm.NoOne,
      notes: "",
    });

    const onSubmit = async () => {
      await FormService.send(form);
    };

    return {
      onSubmit,
      form,
    };
  },
});
